export default __webpack_public_path__ + "static/media/gallery_09.bc7ae4d8.jpg";